// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + "sentry-browser" + "." + "7f3a972e96872ab83fc6" + ".js";
};